module.exports = "build/assets/singleWhispWhiteBg.333232c3.png";